import React, { useState, useRef, useCallback, useEffect } from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import { Edit } from 'react-feather';
import VirtualList from '../components/VirtualList';
import LoadingSpinner from '../../InitialPage/Sidebar/LoadingSpinner';
import { getAsnSourceFileName, isAsnOriginShipment } from './mappings-asn';

const getStatusBadgeStyle = (status) => {
  switch ((status || '').toLowerCase()) {
    case 'not started':
      return { backgroundColor: '#6c757d', color: '#fff' };
    case 'partially received':
      return { backgroundColor: '#ffeb3b', color: '#212529' };
    case 'completed':
    case 'closed':
      return { backgroundColor: '#28a745', color: '#fff' };
    default:
      return { backgroundColor: '#e0e0e0', color: '#000000' };
  }
};

const asnBadgeStyle = {
  backgroundColor: '#02a8b5',
  color: '#fff',
  marginLeft: '6px',
};

const MappingsTile = ({ shipments = [], loading = false, onViewShipment }) => {
  const [columnCount, setColumnCount] = useState(6);
  const [columnWidth, setColumnWidth] = useState(300);
  const tileRef = useRef(null);

  const updateColumnSettings = useCallback(() => {
    if (tileRef.current) {
      const width = tileRef.current.offsetWidth;
      let columns = 6;
      if (width < 576) {
        columns = 1;
      } else if (width < 768) {
        columns = 3;
      } else if (width < 992) {
        columns = 5;
      } else {
        columns = 6;
      }
      const newColumnWidth = Math.max(width / columns, 200);
      setColumnCount(columns);
      setColumnWidth(newColumnWidth);
    }
  }, []);

  useEffect(() => {
    updateColumnSettings();
    window.addEventListener('resize', updateColumnSettings);
    return () => window.removeEventListener('resize', updateColumnSettings);
  }, [updateColumnSettings]);

  const itemData = shipments.map(shipment => <MappingsTileItem shipment={shipment} key={shipment.receivingShipmentID} onViewShipment={onViewShipment} />);
  const rowCount = Math.ceil(shipments.length / columnCount);

  return (
    <div className={`shipment-tile-body`} ref={tileRef}>
      {loading && <LoadingSpinner />}
      {
        <VirtualList
          columnCount={columnCount}
          rowCount={rowCount}
          itemData={itemData}
          columnWidth={columnWidth}
          rowHeight={190}
        />
      }
    </div>
  );
};

const MappingsTileItem = ({ shipment, onViewShipment }) => {
  const handleView = e => {
    e.preventDefault();
    e.stopPropagation();
    if (onViewShipment) onViewShipment(shipment);
  };
  return (
    <div key={shipment.receivingShipmentID} className="po-tile">
      <div
        className={`card p-3 m-2 ${shipment.isNewlyCreated ? 'border-success' : ''}`}
        style={{
            border: isAsnOriginShipment(shipment) ? '1.5px solid #02a8b5' : '1px solid #ddd',
          borderRadius: '4px',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
        }}
      >
        <div className="tile-actions" style={{ textAlign: 'right' }}>
          <ButtonGroup size="sm">
            <Button type="button" variant="light" onClick={handleView}>
              <Edit size={16} />
            </Button>
          </ButtonGroup>
        </div>
        <div className="d-flex justify-content-between">
          <div className="d-flex flex-row align-items-center">
            <div className="ms-2 c-details">
              <h6 className="mb-0">{shipment.shipmentNumber}</h6>
              <span>{shipment.shipmentDate || 'N/A'}</span>
              <div className="text-muted" style={{ fontSize: '12px', marginTop: '2px' }}>
                Appt: {shipment.appointmentDateTime || 'N/A'}
              </div>
            </div>
          </div>
        </div>
        <div className="mt-1">
          <span className="badge" style={getStatusBadgeStyle(shipment.status)}>
            {shipment.status || 'N/A'}
          </span>
          {isAsnOriginShipment(shipment) ? (
            <span className="badge" style={asnBadgeStyle} title={getAsnSourceFileName(shipment)}>
              ASN
            </span>
          ) : null}
        </div>
        {shipment.supplierName ? (
          <div className="mt-1">
            <h5 className="heading text-truncate" title={shipment.supplierName}>
              {shipment.supplierName}
            </h5>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default MappingsTile;
